class GigiCollectionSearch extends HTMLElement {
  constructor() {
    super();
    this.onInput = this.onInput.bind(this);
    this.onReset = this.onReset.bind(this);
    this.applyFilter = this.applyFilter.bind(this);
    this.onResize = this.onResize.bind(this);
    this.rowHeight = 0;
  }

  connectedCallback() {
    this.input = this.querySelector('.gigi-collection-toolbar__search-input');
    this.resetButton = this.querySelector('.gigi-collection-toolbar__search-reset');
    this.gridContainer = document.getElementById('ProductGridContainer');

    if (!this.input || !this.gridContainer) return;

    this.input.addEventListener('input', this.onInput);
    this.resetButton?.addEventListener('click', this.onReset);
    window.addEventListener('resize', this.onResize);

    this.observer = new MutationObserver(this.applyFilter);
    this.observer.observe(this.gridContainer, { childList: true, subtree: true });
  }

  disconnectedCallback() {
    this.input?.removeEventListener('input', this.onInput);
    this.resetButton?.removeEventListener('click', this.onReset);
    window.removeEventListener('resize', this.onResize);
    this.observer?.disconnect();
  }

  onResize() {
    this.applyFilter();
  }

  onInput() {
    const hasValue = this.input.value.trim().length > 0;
    this.resetButton?.classList.toggle('hidden', !hasValue);
    this.applyFilter();
  }

  onReset() {
    this.input.value = '';
    this.resetButton?.classList.add('hidden');
    this.applyFilter();
    this.input.focus();
  }

  measureRowHeight(grid) {
    const sample = grid?.querySelector('.grid__item:not([hidden])') || grid?.querySelector('.grid__item');
    if (!sample) return;

    const height = Math.ceil(sample.getBoundingClientRect().height);
    if (height > 0) this.rowHeight = height;
  }

  syncEmptyStateHeight(emptyState) {
    if (!emptyState || !this.rowHeight) return;
    emptyState.style.minHeight = `${this.rowHeight}px`;
  }

  applyFilter() {
    const grid = this.gridContainer?.querySelector('#product-grid');
    if (!grid) return;

    if (typeof FacetFiltersForm !== 'undefined' && FacetFiltersForm.applyCurrentClientFilters(this)) {
      return;
    }

    const emptyState = this.gridContainer?.querySelector('.gigi-collection-search-empty');
    const query = this.input.value.trim().toLowerCase();
    let visibleCount = 0;

    this.measureRowHeight(grid);

    grid.querySelectorAll('.grid__item').forEach((item) => {
      const title = item.querySelector('.card__heading')?.textContent.trim().toLowerCase() || '';
      const matches = !query || title.includes(query);
      item.hidden = !matches;
      if (matches) visibleCount += 1;
    });

    const showEmpty = query.length > 0 && visibleCount === 0;
    emptyState?.classList.toggle('hidden', !showEmpty);
    grid.classList.toggle('gigi-collection-search--empty', showEmpty);

    if (showEmpty) {
      this.syncEmptyStateHeight(emptyState);
    } else {
      emptyState?.style.removeProperty('min-height');
    }
  }
}

customElements.define('gigi-collection-search', GigiCollectionSearch);
